import { Utils } from '../Utils.js';

const getPageTitle = (pageName) => {
    var title = '| National Research Group \"(NRG)\" Entertainment Market Research';

    switch (pageName) {
        case 'homepage':
            return `Thinking ${title}`;
        default:
            return `${Utils.ucFirst(pageName)} ${title}`;
    }
}

const changePageTitle = (pageName) => {
    document.title = getPageTitle(pageName);
}

export { changePageTitle };
